<svg
  class="icon"
  [style.width.px]="width()"
  [style.height.px]="height() || width()"
>
  <use [attr.href]="'images/sprite.svg#' + icon()"></use>
</svg>
